/* lp-feral-card — built by feral·landers. Edit landers/feral-card/page.js, not this. */
(function(){"use strict";var LP_ROOT="#lp-feral-card",LP_NAME="feral-card";
/* ═══════════════════════════════════════════════════════════════════════════
   feral·landers — base.js
   Wrapped in one IIFE by kit/build.mjs, which also injects LP_ROOT and LP_NAME.
   A lander's own page.js runs after this and can use everything below.
   No framework, no modules — this is a theme asset and it has to run alone.
   ═══════════════════════════════════════════════════════════════════════════ */

var LP = {};
var root = document.querySelector(LP_ROOT);
if (!root) return;                       // the section is not on this page

var $  = function (sel, ctx) { return (ctx || root).querySelector(sel); };
var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isPhone = function () { return window.matchMedia('(max-width: 989px)').matches; };

LP.root = root; LP.$ = $; LP.$$ = $$; LP.reduced = reduced; LP.isPhone = isPhone;

/* Everything the data bridge hands us came out of Shopify admin, where a product
   title legitimately contains & and quotes. Escape before it touches innerHTML. */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
LP.esc = esc;

/* ── THE DATA BRIDGE ──────────────────────────────────────────────────────
   The ~30 lines of Liquid in the section shell emit live product data as JSON:
   variant ids, size labels, availability and PRICES ALREADY RENDERED BY THE
   SERVER in the visitor's market currency.
   🚨 Never format money in here. Shopify does not currency-convert a number you
   typed; the server's string is the only one that is definitely true, and a
   client that cannot convert must do nothing rather than show GBP.
   (part: server-honest-money-fx-upgrade)                                     */
LP.data = (function () {
  var el = document.getElementById('lp-' + LP_NAME + '-data');
  if (!el) return { products: {}, settings: {} };
  try { return JSON.parse(el.textContent); } catch (e) { return { products: {}, settings: {} }; }
})();
LP.product = function (key) { return LP.data.products && LP.data.products[key]; };

document.body.classList.add('lp-live');

/* ── PORTAL ───────────────────────────────────────────────────────────────
   🚨 The lander root sets `overflow-x: clip`, and in Safari ANY ancestor with
   overflow clip/hidden, a transform or a filter kills `position: fixed` — the
   element scrolls with the page. Invisible on desktop Chrome. So anything fixed
   is moved out to <body> before it is ever shown.
   (part: fixed-dock-outside-the-clip-ancestor · portal-overlay-to-body)      */
LP.portal = function (el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); return el; };
$$('[data-lp-portal]').forEach(LP.portal);

/* ── THE THEME CHROME IS A MOVING TARGET ──────────────────────────────────
   Two stacked sticky layers (marquee at top:0, header at top:32px) and the group
   COLLAPSES on scroll: 105px at rest, 73px in motion. A hardcoded number is
   wrong half the time.
   🚨 The collapse is a CSS transition, so it finishes AFTER the last scroll
   event — one reading latches a stale value and a full-height band scrolls
   through the gap. Re-measure at ~200ms and ~500ms after scrolling stops.     */
(function chrome() {
  var group = document.querySelector('.shopify-section-group-header-group') ||
              document.querySelector('#shopify-section-header') ||
              document.querySelector('header');
  if (!group) return;
  var write = function () {
    var b = group.getBoundingClientRect().bottom;
    root.style.setProperty('--lp-chrome', Math.max(0, Math.round(b)) + 'px');
  };
  var t1, t2;
  var onScroll = function () {
    write();
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(write, 200);
    t2 = setTimeout(write, 500);
  };
  write();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── REVEALS ──────────────────────────────────────────────────────────────
   Arms only once we know JS is alive, so a script failure leaves a readable
   page rather than a blank one. Nothing in the first viewport is armed: it
   would fade in on load, read as a slow page, and cost LCP on the one element
   that matters most.                                                          */
(function reveals() {
  var items = $$('.lp-rv');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var fold = window.innerHeight;
  var below = items.filter(function (el) { return el.getBoundingClientRect().top > fold * 0.9; });
  if (!below.length) return;
  root.classList.add('is-armed');
  items.forEach(function (el) { if (below.indexOf(el) < 0) el.classList.add('is-in'); });
  if (reduced) { below.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.02 });
  below.forEach(function (el) { io.observe(el); });
})();

/* ── THE CART ─────────────────────────────────────────────────────────────
   The proven add-from-anywhere flow, lifted from assets/feral-plp.js.
   🚨 Send it FORM-ENCODED and ask for the drawer sections in the SAME request.
   A JSON body with {items:[…]} genuinely lands the line item and still leaves
   the drawer painting its cached empty state — /cart.js says the item is there
   while the drawer says BAG EMPTY. That is the signature of bypassing the
   section render. (part: cart-add-with-section-rerender)
   The Meta CAPI layer in snippets/feral-events.liquid patches window.fetch and
   fires AddToCart off /cart/add.js by itself — do not emit a second event.    */
var inflight = false;
LP.addToCart = function (items) {
  if (inflight) return Promise.resolve(null);
  inflight = true;
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var fd = new FormData();
  items.forEach(function (it, i) {
    fd.append('items[' + i + '][id]', String(it.id));
    fd.append('items[' + i + '][quantity]', String(it.quantity || 1));
  });
  if (cart && typeof cart.getSectionsToRender === 'function') {
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }
  var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return fetch(url, {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    body: fd
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // Shopify returns a JSON body with `status` for a sold-out variant even
      // when the HTTP status is inconsistently 200.
      if (data.status) throw new Error(data.description || data.message || 'add failed');
      if (cart) {
        // Remove is-empty or the drawer keeps painting its empty state over
        // correct contents. Do NOT open the drawer by hand — renderContents
        // already opens it, and doing both fights the transition.
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(data);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lp-' + LP_NAME, cartData: data });
      }
      return data;
    })
    .finally(function () { inflight = false; });
};

/* ── THE SIZE SHEET ───────────────────────────────────────────────────────
   One sheet, portalled to <body>, populated per-call. Mobile gets a bottom
   sheet, desktop the same node centred (CSS decides) — a bottom sheet on a
   1440px screen is a modal for no reason, and an inline shake on a phone
   happens off-screen.
   The sold-out row stays FOCUSABLE and readable rather than disabled: a
   disabled control is invisible to a screen reader's tab order and throws away
   the most valuable moment on the page — someone who wants a thing you do not
   have. (part: the-buy-box-is-one-pill-in-three-states)                       */
var sheet, scrim, lastFocus;
function ensureSheet() {
  if (sheet) return;
  scrim = document.createElement('div');
  scrim.className = 'lp-sheet-scrim';
  sheet = document.createElement('div');
  sheet.className = 'lp-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose a size');
  document.body.appendChild(scrim);
  document.body.appendChild(sheet);
  scrim.addEventListener('click', closeSheet);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
}
function closeSheet() {
  if (!sheet) return;
  sheet.classList.remove('is-open');
  scrim.classList.remove('is-open');
  document.body.classList.remove('lp-locked');
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
LP.closeSheet = closeSheet;

/**
 * LP.pickSize(productKey, onPick) — onPick(variant) when a size is chosen.
 * Returns false and does nothing if the product is not in the data bridge.
 */
LP.pickSize = function (key, onPick) {
  var p = LP.product(key);
  if (!p) return false;
  ensureSheet();
  lastFocus = document.activeElement;
  var rows = p.variants.map(function (v) {
    var cls = 'lp-sheet__row' + (v.available ? '' : ' is-out');
    var right = v.available
      ? (v.low ? '<span class="lp-sheet__low">low stock</span>' : '')
      : '<span class="lp-sheet__out">sold out</span>';
    return '<button type="button" class="' + cls + '" data-vid="' + v.id + '"' +
           (v.available ? '' : ' data-out="1"') + '>' +
           '<span class="lp-sheet__size">' + esc(v.title) + '</span>' + right + '</button>';
  }).join('');
  sheet.innerHTML =
    '<div class="lp-sheet__head">' +
      '<div><div class="lp-sheet__eyebrow">' + esc(p.eyebrow) + '</div>' +
      '<div class="lp-sheet__title">' + esc(p.title) + '</div></div>' +
      '<button type="button" class="lp-sheet__x" aria-label="Close">&#10005;</button>' +
    '</div>' +
    '<div class="lp-sheet__grid">' + rows + '</div>' +
    '<a class="lp-sheet__link" href="' + esc(p.url) + '">Size guide and full detail &#8599;</a>';
  sheet.querySelector('.lp-sheet__x').addEventListener('click', closeSheet);
  Array.prototype.forEach.call(sheet.querySelectorAll('.lp-sheet__row'), function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('data-out')) { window.location.href = p.url; return; }
      var v = p.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
      closeSheet();
      onPick(v);
    });
  });
  scrim.classList.add('is-open');
  sheet.classList.add('is-open');
  if (isPhone()) document.body.classList.add('lp-locked');
  // Focus the DIALOG, not the first size. `.focus()` on a row trips the
  // :focus-visible heuristics even from a tap, so the first size lights up with
  // a ring and reads as already chosen — on the one control where "nothing is
  // chosen yet" is the whole point. (part: size-deselected-until-the-url-picks-one)
  sheet.setAttribute('tabindex', '-1');
  sheet.focus();
  return true;
};

/* ── THE DOCK ─────────────────────────────────────────────────────────────
   Raised once the hero is behind you, so it never covers the first CTA.       */
LP.dockOn = function (afterEl) {
  var dock = document.querySelector('.lp-dock');   // portalled to <body>, so query the document
  if (!dock || !afterEl) return;
  if (!('IntersectionObserver' in window)) { dock.classList.add('is-up'); return; }
  new IntersectionObserver(function (e) {
    dock.classList.toggle('is-up', !e[0].isIntersecting);
  }, { threshold: 0 }).observe(afterEl);
};

/* Smooth in-page jumps that respect reduced motion. */
LP.jumpTo = function (el) {
  if (!el) return;
  el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
};
$$('[data-lp-jump]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var target = $(a.getAttribute('data-lp-jump'));
    if (!target) return;
    e.preventDefault();
    LP.jumpTo(target);
  });
});

window.LP = LP;

/* FERAL CARD — page.js. Runs after the kit's base.js (LP, $, $$ are live) and after
   hf-rewards-core.js (window.HFRewards), the same pure rules the engine runs.
   ONE state object paints the page, so a real customer and the preview switcher go
   down the same path. Money is always money: a rate is "£5 back every £100", a
   distance is "£62 to your next £5", a gate is "£75 spent". Never a percent. */

var S = LP.data.settings || {};
var X = LP.data.extras || {};
var C = S.copy || {};
var L = S.levels || [];
var R = window.HFRewards;
var Access = window.HFMemberAccess;
var esc = LP.esc;
var el = function (k) { return LP.root.querySelector('[data-fc="' + k + '"]'); };
var PREVIEW = !!X.theme_role && X.theme_role !== 'main';
var CALM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── MONEY ─────────────────────────────────────────────────────────────────
   The engine counts eligible spend in GBP pence. A shopper reads it in their own
   money at the programme's display rate (per_pct: their money per £5); a currency
   with no rate reads GBP, which is the figure that counts. Rewards are the fixed
   amount the rules set for their currency (drop_n), times the level multiplier. */
var PER = S.gbp_per_pct || 5;
var perPct = +X.per_pct || 0, DROP_N = +X.drop_n || 0, FX = +X.fx || 0;
var SYM = perPct && X.sym ? X.sym : '£';
var RATE = perPct && X.sym ? perPct / PER : 1;
function num(n) { return Math.round(n).toLocaleString('en-GB'); }
/* spend, from GBP pence: `up` rounds a distance up, so it never promises too little */
function spend(minor, up) { var v = minor / 100 * RATE; return SYM + num(up ? Math.ceil(v - 1e-9) : Math.floor(v + 1e-9)); }
function reward(x) { return DROP_N && X.sym ? X.sym + num(DROP_N * x) : '£' + num((((S.drops || {}).value || {}).GBP || 5) * x); }
function bonusMoney(gbp) { return FX && X.sym ? X.sym + num(gbp * FX) : '£' + num(gbp); }
function gbp(n) { return '£' + num(n); }

var STEP = R ? R.config(S).step : 10000;          /* pence of eligible spend per reward (£100) */
function gateMinor(i) { return Math.round(L[i].min_pct * PER * 100); }
function mult(i) { return R ? R.multiplier(S, i) : 1; }
function row(key) { var r = ((S.benefits || {}).rows || []).find(function (x) { return x.key === key; }); return r ? r.at : {}; }
/* a level keeps what the level below had unless it has its own entry */
function at(key, i) { var a = row(key); for (var k = i; k >= 0; k--) { var e = a[(L[k] || {}).key]; if (e) return e; } return null; }
function hours(key, i) { var e = at(key, i); return e && /^(\d+)h$/.test(e.v || '') ? parseInt(e.v, 10) : 0; }
function bonusGbp(i) { var e = row('levelup')[(L[i] || {}).key]; return e && e.gbp ? e.gbp : 0; }
function levelIndex(key) { for (var i = 0; i < L.length; i++) if (L[i].key === key) return i; return -1; }

var WORDS = { step: spend(STEP), clears: (S.drops || {}).clears_days || 45, days: (S.drops || {}).expires_days || 180, gbp_step: gbp(STEP / 100), spend500: spend(gateMinor(L.length - 1)) };
L.forEach(function (l, i) {
  WORDS['label_' + l.key] = l.label;
  WORDS['gate_' + l.key] = spend(gateMinor(i), true);
  WORDS['gbp_gate_' + l.key] = gbp(gateMinor(i) / 100);
  WORDS['back_' + l.key] = reward(mult(i));
  WORDS['gbp_back_' + l.key] = gbp((((S.drops || {}).value || {}).GBP || 5) * mult(i));
  if (bonusGbp(i)) { WORDS['bonus_' + l.key] = bonusMoney(bonusGbp(i)); WORDS['gbp_bonus_' + l.key] = gbp(bonusGbp(i)); }
});
function fill(s, o) { o = o || {}; return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : WORDS[k] != null ? WORDS[k] : ''; }); }

/* ── STATE ─────────────────────────────────────────────────────────────────
   The audited ledger (the customer's feral_loyalty metafields) is the only source
   of a member's spend. Signed in with no orders and no ledger: the start of the card.
   Signed in, a buyer, no ledger yet: the card is on its way. Never Shopify's
   VAT-inclusive total_spent. */
function okInt(v) { return v !== '' && v != null && Number.isSafeInteger(+v) && +v >= 0; }
function memberOf(net, orders, level, cursor, extra) {
  var s = R.state(S, { net_minor: net, orders: orders, level: level, drop_cursor: cursor });
  return Object.assign(s, { name: X.first_name || '', since: X.since || '', credit: X.credit || '' }, extra || {});
}
function realState() {
  if (!X.logged_in || !R) return { guest: true };
  var li = levelIndex(X.mf_level);
  if (okInt(X.mf_net_minor) && okInt(X.mf_orders) && okInt(X.mf_drop_cursor) && li >= 0) return memberOf(+X.mf_net_minor, +X.mf_orders, li, +X.mf_drop_cursor);
  if (+X.orders_count === 0 && !X.mf_level) return memberOf(0, 0, 0, 0);
  return { pending: true, name: X.first_name || '' };
}
/* Fictional members for the preview theme only (?fc_member=…). Never on main. */
var FIXTURES = {
  guest: function () { return { guest: true }; },
  pending: function () { return { pending: true, name: 'Harry' }; },
  zero: function () { return memberOf(0, 0, 0, 0, { name: 'Harry', since: '2026' }); },
  stray: function () { return memberOf(3826, 1, 1, 0, { name: 'Harry', since: '2026' }); },
  wild: function () { return memberOf(13800, 3, 2, 1, { name: 'Harry', since: '2025', credit: reward(1) }); },
  unhinged: function () { return memberOf(31000, 6, 3, 3, { name: 'Harry', since: '2024', credit: reward(2) }); },
  feral: function () { return memberOf(64000, 11, 4, 6, { name: 'Harry', since: '2023' }); }
};
var fixtureKey = PREVIEW ? new URLSearchParams(location.search).get('fc_member') : null;
var state = fixtureKey && FIXTURES[fixtureKey] && R ? FIXTURES[fixtureKey]() : realState();

/* ── LINKS ─────────────────────────────────────────────────────────────────
   The card itself lives on the account page. Signed out, "See your card" goes
   straight to Shopify's sign-in and comes back to it. On a preview theme every
   link stays on the preview, and the account opens as the same fictional member. */
var ACCOUNT = '/pages/your-feral';
function accountURL() {
  var u = new URL(ACCOUNT, location.origin);
  if (PREVIEW) { u.searchParams.set('preview_theme_id', X.theme_id); if (fixtureKey) u.searchParams.set('fa_preview', fixtureKey === 'guest' ? 'guest' : fixtureKey === 'pending' ? 'pending' : fixtureKey === 'zero' ? 'empty' : 'member'); }
  return u.pathname + u.search;
}
function signinURL() {
  if (PREVIEW || !X.login) return accountURL();
  var u = new URL(X.login, location.origin); u.searchParams.set('return_to', ACCOUNT); return u.pathname + u.search;
}

/* ── THE CARD ──────────────────────────────────────────────────────────────
   The HOW FERAL R U card, unchanged in material: five finishes, the real wordmark
   as a mask, a tally scratch per level. Your own card carries your name. */
var LEAN = [[1.2, -.6], [.4, .3], [1.6, -.2], [.2, -1]];
function tally(n) {
  var s = '', m = Math.min(n, 4);
  for (var k = 0; k < m; k++) { var x = 35 - (m - 1 - k) * 10; s += '<path d="M' + (x + LEAN[k][0]) + ' 3L' + (x + LEAN[k][1]) + ' 33"/>'; }
  return '<svg viewBox="-4 0 48 36" aria-hidden="true" focusable="false">' + s + '</svg>';
}
function cardArt(i) { return +i === 2 ? X.art_feral || '' : X['art_' + (L[i] || {}).key] || ''; }
function card(i, o) {
  o = o || {};
  var l = L[i] || {}, art = cardArt(i), css = [];
  if (art) css.push("--hf-art:url('" + art + "')");
  if (X.wordmark) css.push("--hf-mark:url('" + X.wordmark + "')");
  var h = '<div class="hf-card' + (art ? ' has-art' : '') + '" data-level="' + i + '" style="' + esc(css.join(';')) + '">'
    + '<i class="hf-card__mat" aria-hidden="true"><i class="hf-card__art"></i><i class="hf-card__imprint"></i><i class="hf-card__cuts"><i class="hf-card__foil"></i></i><i class="hf-card__grain"></i><i class="hf-card__sheen"></i></i>'
    + (X.wordmark ? '<b class="hf-card__mark is-img"></b>' : '<b class="hf-card__mark">FERAL</b>')
    + '<b class="hf-card__edition"><i>0' + (+i + 1) + ' / 0' + L.length + '</i></b>'
    + '<i class="hf-card__tally" data-n="' + i + '">' + tally(+i) + '</i>'
    + '<b class="hf-card__name' + ((l.label || '').length > 6 ? ' is-long' : '') + '">' + esc(l.label || '') + '</b>';
  if (o.name || o.since) h += '<div class="hf-card__who">' + (o.name ? '<b>' + esc(o.name) + '</b>' : '') + (o.since ? '<i>' + esc('SINCE ' + o.since) + '</i>' : '') + '</div>';
  return h + '</div>';
}

/* ── HERO ──────────────────────────────────────────────────────────────── */
function paintHero() {
  var g = !!state.guest, p = !!state.pending, M = C.member || {}, G = C.guest || {};
  var hero = el('hero');
  hero.classList.toggle('is-guest', g); hero.classList.toggle('is-member', !g);
  el('eyebrow').textContent = g || !state.name ? C.eyebrow_guest : fill(C.eyebrow_member, { name: String(state.name).toUpperCase() });
  el('tagline').textContent = C.tagline;
  /* the instrument row, as on the parcel emails: a red diamond, a spaced label, a boxed tag */
  el('tag').textContent = g || p ? (L[0].label + ' → ' + L[L.length - 1].label) : '0' + (state.level + 1) + ' / 0' + L.length + ' · ' + L[state.level].label;
  el('guest').hidden = !g; el('member').hidden = g;
  el('fan').hidden = !g; el('mine').hidden = g;
  if (g) {
    el('guest-lede').textContent = fill(G.lede);
    el('signin').textContent = G.cta; el('signin').href = signinURL();
    el('already').textContent = fill(G.already);
    el('cardnote').textContent = G.fan || '';
    var slots = [-2, -1, 2, 1, 0];
    el('fan').innerHTML = L.map(function (l, i) { return '<span class="fc-fan__card" style="--slot:' + slots[i] + ';--depth:' + Math.abs(slots[i]) + '">' + card(i) + '</span>'; }).join('');
    return;
  }
  el('see').href = accountURL();
  el('cardnote').textContent = '';
  if (p) {
    el('your').textContent = M.pending;
    el('progress-h').textContent = M.pending_note; el('progress-h').classList.add('is-quiet');
    el('bar').hidden = true; el('progress-note').hidden = true; el('level').hidden = true; el('credit').hidden = true;
    el('mine').innerHTML = card(0, { name: state.name }); el('mine').setAttribute('aria-label', M.pending);
    return;
  }
  var lvl = L[state.level] || {};
  el('your').textContent = fill(M.your, { label: lvl.label });
  el('mine').innerHTML = card(state.level, { name: state.name, since: state.since });
  el('mine').setAttribute('aria-label', 'Your FERAL CARD: ' + lvl.label);
  paintProgress();
  paintLevel();
  var credit = el('credit'); credit.hidden = !state.credit;
  if (state.credit) credit.textContent = fill(M.credit, { money: state.credit });
}

/* The next reward, as money, on a bar with three labels: where this £100 started,
   where you are, and the spend that pays the next reward. */
function nextReward() {
  var cursor = state.drop_cursor, start = cursor * STEP, end = start + STEP;
  var x = R.backAt(S, cursor + 1, state.level, state.orders);
  return { start: start, end: end, left: Math.max(0, end - state.net_minor), reward: reward(x), fill: Math.max(0, Math.min(1, (state.net_minor - start) / STEP)) };
}
function paintProgress() {
  var M = C.member || {}, n = nextReward(), h = el('progress-h'), note = el('progress-note');
  h.classList.remove('is-quiet');
  if (state.orders < 1) { h.textContent = M.first; note.hidden = false; note.textContent = fill(M.first_note); }
  else { h.textContent = fill(M.to_next, { money: spend(n.left, true), reward: n.reward }); note.hidden = true; }
  el('bar').hidden = false;
  var pct = (n.fill * 100).toFixed(1) + '%';
  el('bar-fill').style.width = pct; el('bar-dot').style.left = pct;
  el('bar-start').textContent = fill(M.bar_start, { money: spend(n.start) });
  el('bar-end').textContent = fill(M.bar_end, { money: spend(n.end), reward: n.reward });
  var you = el('bar-you'); you.textContent = fill(M.bar_you, { money: spend(state.net_minor) });
  /* the "You" label sits over the dot, held inside the bar at both ends */
  you.style.setProperty('--x', n.fill.toFixed(3));
  el('bar').setAttribute('aria-label', fill(M.bar_you, { money: spend(state.net_minor) }) + ' spent. ' + fill(M.bar_end, { money: spend(n.end), reward: n.reward }) + '. ' + h.textContent + '.');
}
function addsLine(i) {
  var bits = [], below = i - 1;
  if (mult(i) > mult(below)) bits.push(fill('{r} back every {step}', { r: reward(mult(i)) }));
  if (bonusGbp(i)) bits.push(bonusMoney(bonusGbp(i)) + ' level-up bonus');
  var e = hours('early', i); if (e && e !== hours('early', below)) bits.push(e + ' hours early access to drops and events');
  if (!bits.length) return '';
  return bits.length > 1 ? bits.slice(0, -1).join(', ') + ' and ' + bits[bits.length - 1] : bits[0];
}
function paintLevel() {
  var M = C.member || {}, node = el('level'), top = L.length - 1;
  node.hidden = false;
  if (state.level >= top) { node.textContent = fill(M.level_top, { label: L[top].label }); return; }
  var next = state.level + 1;
  if (state.orders < 1) next = 1;
  var need = Math.max(0, gateMinor(next) - state.net_minor);
  var head = next === 1 ? L[1].label + ': your first order' : fill(M.level_next, { money: spend(need, true), label: L[next].label });
  var adds = addsLine(next);
  node.innerHTML = '<b>' + esc(head) + '</b>' + (adds ? ' <span>' + esc(fill(M.level_adds, { label: L[next].label, adds: adds })) + '</span>' : '');
}

/* ── EARLY ACCESS: invitations from the release calendar, members only. ──── */
function paintAccess() {
  var box = el('access'), A = C.access || {};
  if (state.guest || state.pending || !Access) { box.hidden = true; return; }
  var opens = -1; for (var k = 0; k < L.length; k++) if (hours('early', k)) { opens = k; break; }
  if (opens < 0 || state.level < opens) { box.hidden = true; return; }
  var cal = []; try { cal = JSON.parse(X.invitations || '[]'); } catch (_) {}
  var rows = Access.forMember(cal, state.level, Date.now(), S);
  box.hidden = false;
  box.innerHTML = '<h2 class="fc-access__h" id="fc-access-h">' + esc(A.h) + '</h2>' + (!rows.length ? '<p class="fc-access__empty">' + esc(A.empty) + '</p>'
    : '<ul class="fc-access__list">' + rows.map(function (r) {
      var when = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }).format(new Date(r.opens_at));
      return '<li><div><p class="lp-eyebrow">' + esc((A.kind || {})[r.kind] || '') + '</p><h3>' + esc(r.title) + '</h3><p>' + esc(r.status === 'open' ? A.open : fill(A.opens, { when: when })) + '</p></div>'
        + (r.status === 'open' && r.url ? '<a class="lp-cta lp-cta--ghost" href="' + esc(r.url) + '">' + esc(r.kind === 'night' ? A.cta_night : A.cta) + '</a>' : '') + '</li>';
    }).join('') + '</ul>');
}

/* ── HOW IT WORKS: three steps, then the first £500 as it actually pays ──── */
function paintHow() {
  var H = C.how || {};
  el('how-eyebrow').textContent = H.eyebrow; el('how-h').textContent = H.h;
  el('steps').innerHTML = (H.steps || []).map(function (s, i) {
    return '<li class="fc-step"><span class="fc-step__n">0' + (i + 1) + '</span><b class="fc-step__fig">' + esc(fill(s.fig)) + '</b><h3 class="fc-step__h">' + esc(fill(s.h)) + '</h3><p>' + esc(fill(s.p)) + '</p></li>';
  }).join('');
  /* Every milestone to the top gate and every gate on the way, in spend order. Each
     £100 pays at the level reached by then (the engine's backAt); a bonus pays once. */
  var top = L.length - 1, end = gateMinor(top), events = [], regular = 0, bonus = 0;
  for (var k = 1; k * STEP <= end; k++) { var x = R.backAt(S, k, 0, 1); regular += x; events.push({ at: k * STEP, kind: 'back', x: x }); }
  for (var i = 2; i <= top; i++) { events.push({ at: gateMinor(i), kind: 'gate', i: i }); bonus += bonusGbp(i); }
  events.sort(function (a, b) { return a.at - b.at || (a.kind === 'gate' ? -1 : 1); });
  /* one row per spend point: a gate and a milestone at the same spend share a row */
  var rows = [];
  events.forEach(function (e) { var last = rows[rows.length - 1]; if (last && last.at === e.at) last.items.push(e); else rows.push({ at: e.at, items: [e] }); });
  rows.unshift({ at: 0, first: true, items: [{ kind: 'gate', i: 1 }] });
  el('example-h').textContent = fill(H.example_h);
  el('example-list').innerHTML = rows.map(function (r) {
    var gate = r.items.find(function (e) { return e.kind === 'gate'; }), back = r.items.find(function (e) { return e.kind === 'back'; });
    var got = [];
    if (back) got.push('<b class="fc-plus">+' + esc(reward(back.x)) + '</b> <span>money back</span>');
    if (gate && bonusGbp(gate.i)) got.push('<b class="fc-plus">+' + esc(bonusMoney(bonusGbp(gate.i))) + '</b> <span>level-up bonus</span>');
    return '<li class="fc-ex' + (gate ? ' is-gate' : '') + '"' + (gate ? ' data-level="' + gate.i + '"' : '') + '><span class="fc-ex__at">' + esc(r.first ? H.example_first : spend(r.at, true)) + '</span>'
      + '<span class="fc-ex__what">' + (gate ? '<b class="fc-ex__lvl">' + esc(fill(H.example_gate, { label: L[gate.i].label })) + '</b>' : '') + got.map(function (g) { return '<span class="fc-ex__got">' + g + '</span>'; }).join('') + '</span></li>';
  }).join('');
  var regularMoney = reward(regular), bonusTotal = bonusMoney(bonus);
  var total = DROP_N && X.sym && FX ? X.sym + num(DROP_N * regular + Math.round(bonus * FX)) : '£' + num((((S.drops || {}).value || {}).GBP || 5) * regular + bonus);
  el('example-total').textContent = fill(H.example_total, { total: total });
  el('example-split').textContent = fill(H.example_split, { regular: regularMoney, bonus: bonusTotal });
  el('vat').textContent = H.vat;
}

/* ── THE LEVELS: one card per level. Five columns on a desktop with their rows
   lined up (subgrid), a stack on a phone with a label beside every value, so no
   two cells ever share a line (the old phone table read "DANCEFLOOR5%"). ──── */
function paintLevels() {
  var V = C.levels || {};
  el('levels-eyebrow').textContent = V.eyebrow; el('levels-h').textContent = V.h; el('levels-lede').textContent = V.lede;
  var mine = state.guest || state.pending ? -1 : state.level;
  /* drops and events open the same hours early at every level today: one row says both */
  var same = L.every(function (l, i) { return hours('early', i) === hours('nights', i); });
  el('grid').innerHTML = L.map(function (l, i) {
    var gate = i === 0 ? V.free : i === 1 ? V.first : fill(V.spend, { money: spend(gateMinor(i), true) });
    var back = i === 0 ? '' : fill(V.back_v, { reward: reward(mult(i)) });
    var e = hours('early', i), n = hours('nights', i), b = bonusGbp(i);
    var cell = function (k, label, value) { return '<div class="fc-lv__row" data-row="' + k + '"><dt>' + esc(label) + '</dt><dd' + (value ? '' : ' class="is-none"') + '>' + esc(value || (k === 'back' ? V.back_none : V.none)) + '</dd></div>'; };
    return '<li class="fc-lv' + (i === mine ? ' is-mine' : '') + '" data-level="' + i + '">'
      + '<div class="fc-lv__card">' + card(i) + '</div>'
      + '<div class="fc-lv__name"><h3>' + esc(l.label) + (i === mine ? ' <span class="fc-chip">' + esc(V.yours) + '</span>' : '') + '</h3><p>' + esc((V.lede_card || {})[l.key] || '') + '</p></div>'
      + '<dl class="fc-lv__rows">' + cell('gate', V.gets_in, gate) + cell('back', V.back, back) + cell('bonus', V.bonus, b ? fill(V.bonus_v, { money: bonusMoney(b) }) : '')
      + (same ? cell('early', V.access, e ? fill(V.hours, { n: e }) : '') : cell('early', V.early, e ? fill(V.hours, { n: e }) : '') + cell('nights', V.nights, n ? fill(V.hours, { n: n }) : '')) + '</dl></li>';
  }).join('');
  el('grid').classList.toggle('is-rows-4', same);
}

/* ── QUESTIONS AND TERMS ───────────────────────────────────────────────── */
function paintFaq() {
  var F = C.faq || {};
  el('faq-h').textContent = F.h;
  el('faq').innerHTML = (F.items || []).map(function (it) {
    return '<details class="fc-q"><summary><span>' + esc(fill(it.q)) + '</span><i aria-hidden="true"></i></summary><p>' + esc(fill(it.a)) + '</p></details>';
  }).join('');
  var T = C.terms || {};
  el('terms-h').textContent = T.h;
  el('terms-body').innerHTML = (T.sections || []).map(function (s) { return '<h3>' + esc(s.h) + '</h3><p>' + esc(fill(s.p)) + '</p>'; }).join('');
  el('terms-help').textContent = T.help; el('terms-privacy').textContent = T.privacy; el('terms-store').textContent = T.store;
  /* a link to #feral-card-terms opens them */
  if (location.hash === '#feral-card-terms') el('terms-fold').open = true;
}

function paintEnd() {
  var E = C.end || {}, g = !!state.guest;
  el('end-h').textContent = g || state.pending ? E.guest_h : E.member_h;
  var next = el('end-next');
  if (!g && !state.pending) { var n = nextReward(); next.hidden = false; next.textContent = fill((C.member || {}).to_next, { money: spend(n.left, true), reward: n.reward }) + '.'; }
  else { next.hidden = true; }
  el('end-shop').textContent = E.shop;
  var si = el('end-signin'); si.hidden = !g; si.textContent = E.signin; si.href = signinURL();
}

/* ── MOTION: the material light follows the pointer on a desktop; paused when
   the card is off screen or the device asks for less motion. ───────────── */
function cardsVisible() {
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-visible', e.isIntersecting && !CALM); }); }, { threshold: .05 });
  LP.root.querySelectorAll('.fc-hero .hf-card').forEach(function (c) { io.observe(c); });
}

/* ── PREVIEW ONLY: view the page as each kind of visitor. ──────────────── */
function paintView() {
  if (!PREVIEW) return;
  var v = el('view'), list = [['guest', 'Signed out'], ['pending', 'Card on its way'], ['zero', 'No orders yet'], ['stray', L[1].label], ['wild', L[2].label], ['unhinged', L[3].label], ['feral', L[4].label]];
  v.hidden = false; document.body.classList.add('fc-viewing');
  v.innerHTML = '<b>PREVIEW · VIEW AS</b>' + list.map(function (x) { return '<button type="button" data-fc-as="' + x[0] + '" aria-pressed="' + ((fixtureKey || (state.guest ? 'guest' : '')) === x[0]) + '">' + esc(x[1]) + '</button>'; }).join('');
  v.addEventListener('click', function (e) { var b = e.target.closest('[data-fc-as]'); if (!b) return; var u = new URL(location.href); u.searchParams.set('fc_member', b.dataset.fcAs); location.href = u.href; });
}

paintHero(); paintAccess(); paintHow(); paintLevels(); paintFaq(); paintEnd(); paintView(); cardsVisible();
if (PREVIEW) document.title = 'FERAL CARD · preview';

})();